import { vuexHandbook } from '@/store/composition/handbook'
import { CountryApi } from '@/api/handbook/Country/CountryApi'

const state = () => ({
  ...vuexHandbook.createState(),
  api: CountryApi
})

const getters = {
  ...vuexHandbook.createGetters()
}

const mutations = {
  ...vuexHandbook.createMutations()
}

const actions = {
  ...vuexHandbook.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
